const allowedOrigins = [
    'https://www.amazon.com',
    'https://ring.com',
    'https://dev.ring.com',
    'https://qa.ring.com',
    'https://blog.ring.com',
    'https://fr-fr.ring.com',
    'https://it-it.ring.com',
    'https://es-es.ring.com',
    'https://nl-nl.ring.com',
    'https://de-de.ring.com',
    'https://returns.narvar.com',
    'https://images.ctfassets.net', // contentful CDN origin - product images
];

export const allowedLinkOrigins = new Set(allowedOrigins);
